<a class="back-link" (click)="goBack()" [style.color]="textColor()" data-cy="link-back">
  <accredible-icon icon="chevron-left" [style.color]="textColor()" />
  <span>{{ text() }}</span>
</a>
